module.exports = __webpack_public_path__ + "static/pattern-widget-list-32ab84f5594f2bff7d915c629a7312e0.png";